const CheckPropertyEyeCircledIcon = ({ size = '40', ...restProps }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...restProps}
  >
    <circle cx="20" cy="20" r="20" fill="#E3F0FB" />
    <path
      d="M20.4162 30.7459C27.1273 30.7459 32.822 26.3996 34.8324 20.373C32.822 14.3464 27.1273 10 20.4162 10C13.7051 10 8.01041 14.3464 6 20.373C8.01212 26.3996 13.7051 30.7459 20.4162 30.7459Z"
      stroke="#0D0D0D"
      strokeWidth="1.2"
      strokeMiterlimit="10"
    />
    <path
      d="M20.3859 24.7718C22.8082 24.7718 24.7718 22.8082 24.7718 20.3859C24.7718 17.9636 22.8082 16 20.3859 16C17.9636 16 16 17.9636 16 20.3859C16 22.8082 17.9636 24.7718 20.3859 24.7718Z"
      stroke="#0D0D0D"
      strokeWidth="1.2"
      strokeMiterlimit="10"
    />
  </svg>
);

export default CheckPropertyEyeCircledIcon;
